<template>
   <div class="comment bg-light rounded-3 border p-2 " @click="clickDiv()">
      <textarea 
         class="form-control" id="ta-comment" 
         v-model="textComment"
         placeholder="Escriba un comentario aquí..." 
         rows="1" 
         @blur="getOut()"
         @keyup="onChange($event)"
         @focus="onChange($event)"
      ></textarea>
      <div class="row justify-content-between px-3">
         <button type="button" class="btn btn-sm btn-info mt-1 col-3" @click="addComment()" :disabled="diableButton"> <!--  @blur="getOut()"> -->
            <span v-show="adding"  class="spinner-border spinner-border-sm"></span>
                  {{txtBttAdd}}
         </button>
         <button v-if="!diableButton"
            type="button" 
            class="btn btn-sm btn-light mt-1 col-1 fs-15"
            data-bs-toggle="offcanvas" 
            data-bs-target="#offcanvasMention" 
            aria-controls="offcanvasMention"
            :data-cell-id="0"
            >
            @
         </button>
      </div>
      <!--
            @click="addArroba()"
      -->
   </div>
   <ocMention />
</template>

<script>
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex'
import WspService from "../workSpace.service";

import ocMention from '/src/modules/workSpace/components/OcMentionMembers.vue';

export default {
   components: {
      ocMention
   },
   props: {
      cellId: Number
   },
   setup(props) {

      const store = useStore()
      const contentId = store.state.wspace.contentId

      console.log(contentId)
      console.log(store.state.auth.user.id)
      
      const diableButton = ref(true)

      const adding = ref(false)
      const txtBttAdd = ref('')
      const textComment = ref("")
      const boardId = ref(null)

      //watchEffect(() => control(textComment.value))
      onMounted(() => {
         //store.dispatch("wspace/setCloseComment", true)
         document.getElementById('ta-comment').focus()
         adding.value = false
         txtBttAdd.value = 'Guardar'
         boardId.value = WspService.getBoardId(store)
      })
      /*
      function control(txtCnnt) {
         console.log('ta.text: '+txtCnnt)
      }
      */
      function addComment() {
         /*
         console.log(document.getElementById('ta-comment').value)
         console.log(contentId)
         console.log(store.state.auth.user.id)
         */
         diableButton.value = true
         adding.value = true
         txtBttAdd.value = 'Guardando'
         store.dispatch("wspace/setClickDivComment", false)
         //store.dispatch("wspace/setContentId", -1)
         //
         let uAppIndex = store.state.auth.userAppIndex
         if (uAppIndex > -1) {
            let uAppModule = store.state.auth.userAppModule;
            WspService.addAuditContent(
               contentId,                                               // contentId, 
               'CMM',                                                   // codeAudit, 
               store.state.auth.user.id,                                // userId, 
               document.getElementById('ta-comment').value,             // text
               props.cellId,                                            // cellId
               uAppModule.appModuleComponent[uAppIndex].userAppModuleId,// userAppModuleId
               boardId.value                                                  // boardId
               )
            .then(response => {
               //nextTick(() => {
                  console.log(response);
                  store.dispatch("wspace/setContentId", -1)
               //})
            })
            .catch(error => {
               console.log(error);
            });
            //
            console.log('addComent')
         }
      }

      function onChange(event) {
         let area = event.target;
         area.style.overflow = 'hidden';
         area.style.height = area.scrollHeight + 'px';
         diableButton.value = event.target.value.length < 1;
      }

      function clickDiv() {         
         //store.dispatch("wspace/setContentId", -3)
         console.log('clickDiv('+store.state.wspace.closeComment+')('+store.state.wspace.clickDivComment+')');
         store.dispatch("wspace/setClickDivComment", true)
      }

      function getOut() {
         console.log('getOut('+store.state.wspace.closeComment+')('+store.state.wspace.clickDivComment+')');
         store.dispatch("wspace/setCloseComment", diableButton.value)

      }

      return {
         addComment,
         clickDiv,
         diableButton,
         getOut,
         onChange,
         adding,
         txtBttAdd,
         textComment
      }
   },

}
</script>

<style scoped>
.text-comment {
   min-height: 36px;
   max-width: max-content;
}
.fs-15 {
   font-size: 15px;
}
</style>